import { Link } from "react-router-dom";
import Breadcrumbs from "@/components/feature/Breadcrumbs";
import { categories, clues } from "@/mocks/clueData";
import { useSeo } from "@/hooks/useSeo";

export default function CategoriesPage() {
  useSeo({
    title: "主题分类 - 17.cc网友爆料站投稿分类导航",
    description:
      "17.cc网友爆料站的主题分类导航，涵盖娱乐八卦、社会民生、职场内幕、校园热点、消费维权等方向。按你关心的主题浏览网友投稿与线索征集内容。",
    keywords: "17.cc网友爆料,爆料分类,17.cc用户投稿,主题分类,线索征集",
    path: "/categories",
    schema: [
      {
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        name: "主题分类 - 17.cc 网友爆料站",
        description: "17.cc 网友爆料站的全部主题分类与投稿方向。",
        url: "https://17.cc/categories",
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "https://17.cc/" },
          { "@type": "ListItem", position: 2, name: "主题分类", item: "https://17.cc/categories" },
        ],
      },
    ],
  });

  return (
    <div className="mx-auto w-full px-4 py-8 md:px-8 md:py-12">
      <Breadcrumbs items={[{ label: "主题分类" }]} />

      <header className="mt-6 max-w-3xl">
        <h1 className="font-heading text-3xl font-bold tracking-tight text-foreground-950 md:text-4xl">
          投稿主题分类
        </h1>
        <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base">
          我们把网友投稿按主题整理成不同栏目，方便你按兴趣浏览，也方便投稿时选择合适的方向。
          每个分类都会持续更新，欢迎补充你所在领域的线索。
        </p>
      </header>

      <div className="mt-10 flex flex-col gap-6">
        {categories.map((cat) => {
          const preview = clues.filter((clue) => clue.categoryId === cat.id).slice(0, 2);
          return (
            <section
              key={cat.id}
              className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8"
            >
              <div className="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between">
                <div className="flex items-start gap-4">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                    <i className={`${cat.icon} text-2xl`}></i>
                  </span>
                  <div className="max-w-xl">
                    <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
                      {cat.name}
                    </h2>
                    <p className="mt-2 text-sm leading-7 text-foreground-600">{cat.summary}</p>
                    <p className="mt-3 text-xs text-foreground-500">
                      已收录 <strong className="text-foreground-800">{cat.count}</strong> 篇投稿
                    </p>
                  </div>
                </div>
                <Link
                  to={`/clues?category=${cat.id}`}
                  className="inline-flex shrink-0 items-center gap-1.5 self-start whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-4 py-2 text-sm font-semibold text-primary-800 transition-colors hover:bg-primary-100"
                >
                  进入分类
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>

              {preview.length > 0 && (
                <ul className="mt-6 flex flex-col gap-3 border-t border-background-200 pt-5">
                  {preview.map((clue) => (
                    <li key={clue.id} className="flex items-start gap-2.5 text-sm">
                      <i className="ri-article-line mt-0.5 text-base text-accent-600"></i>
                      <Link
                        to={`/clues/${clue.slug}`}
                        className="leading-6 text-foreground-700 hover:text-primary-700"
                      >
                        {clue.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </section>
          );
        })}
      </div>
    </div>
  );
}